import { Box, Dialog, Icon, IconButton, Toolbar, Typography } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import { useEffect, useState } from "react";
import { settings } from "../../../../../../customize/settings";
import Transition from "../../../../../../lib/dialogTransition";
import { getJWT } from "../../../../../../lib/jwt";
import { CellTipoLotto } from "../../../../shared/tableCells";
import { IImageDialogProps } from "./interfaces";

const IMAGE_URL = `${settings.apiUrl}image/`;
const parseNumber = (value: number): string => {
  const _value = parseFloat(String(value).replaceAll(",", "."));
  return Number(_value.toFixed(2)).toLocaleString("it-IT");
};

function ImageDialog({
  cover,
  item,
  canViewStoragePlace,
  isOpen,
  close,
}: IImageDialogProps) {
  const [imageUrl, setImageUrl] = useState<string>();

  useEffect(() => {
    const jwt = getJWT();
    if (cover) {
      const _imageUrl = `${IMAGE_URL}${cover.hdPath}?token=${jwt}`;
      setImageUrl(_imageUrl);
    }
  }, [cover]);
  return (
    <Dialog
      fullScreen
      open={isOpen}
      onClose={close}
      TransitionComponent={Transition}
      PaperProps={{
        sx: {
          m: 0,
          height: "100dvh",
          maxHeight: "100dvh",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <AppBar
        position="relative"
        color="transparent"
        sx={{ boxShadow: "none" }}
      >
        <Toolbar variant="dense">
          <Box sx={{ flex: 1 }} />
          <IconButton
            edge="end"
            color="inherit"
            onClick={close}
            aria-label="close"
          >
            <Icon className="fa-light fa-xmark" sx={{ overflow: "visible" }} />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Box sx={{ px: 2, pb: 1, display: "flex", alignItems: "center", gap: 1 }}>
        <Box>
          <CellTipoLotto dettaglio={item} />
        </Box>
        <Typography variant="h6" component="span">
          {item.lotto?.codice} {item.suffissoCodice}
        </Typography>
      </Box>
      <Box
        sx={{
          px: 2,
          pb: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography variant="body2" component="span">
            {item.lotto?.qualita?.nome}
          </Typography>
          <Typography variant="body2" component="span">
            {parseNumber(item.quantitaUM)} {item.um}
          </Typography>
        </Box>
        {canViewStoragePlace && (
          <Typography variant="body2" component="span" sx={{ textTransform: "uppercase" }}>
            {item.magazzino?.nome}
          </Typography>
        )}
      </Box>
      <Box
        sx={{
          p: 1,
          boxSizing: "border-box",
          flex: 1,
          minHeight: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {!!cover && !!imageUrl && (
          <img
            src={imageUrl}
            alt={cover.name}
            loading="lazy"
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain",
              display: "block",
            }}
          />
        )}
      </Box>
    </Dialog>
  );
}

export default ImageDialog;
